import * as React from 'react';
import debounce from 'lodash.debounce';
/**
 * See lodash debounce docs: https://lodash.com/docs/4.17.15#debounce
 */
var defaultOptions = { leading: false, trailing: true };
export function useDebounce(defaultValue, delay, options) {
    if (delay === void 0) { delay = 500; }
    if (options === void 0) { options = defaultOptions; }
    var _a = React.useState(defaultValue), value = _a[0], setValueImmediately = _a[1];
    var _b = React.useState(false), debouncing = _b[0], setDebouncing = _b[1];
    var _c = React.useState(Date.now()), signal = _c[0], setSignal = _c[1];
    var triggerUpdate = React.useCallback(debounce(function () {
        setDebouncing(false);
        setSignal(Date.now());
    }, delay, options), []);
    /**
     * set debounced value
     * optionally, cancel any debounced value and set value immediately
     */
    var setValue = React.useCallback(function (value, opts) {
        if (opts === void 0) { opts = { immediate: false }; }
        if (opts.immediate === true) {
            triggerUpdate.cancel();
            setValueImmediately(value);
            setSignal(Date.now());
        }
        else {
            setValueImmediately(value);
            setDebouncing(true);
            triggerUpdate();
        }
    }, []);
    // Cancel debounce queue before unmount to prevent memory leak/warning
    React.useEffect(function () {
        return function () {
            triggerUpdate.cancel();
        };
    }, []);
    return [
        value,
        setValue,
        {
            signal: signal,
            debouncing: debouncing
        }
    ];
}
//# sourceMappingURL=useDebounce.js.map